<template>
  <div>
    <WebhookDetail type="edit" :submitting="submitting" :values="data" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import WebhookDetail from '@/views/pages/web-hooks/WebhookDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    WebhookDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      data: {},
      defaultGtip: null
    };
  },

  created() {
    const webhookId = this.$route.params.webhook_id;
    this.getWebhookDetail(webhookId);
  },

  methods: {
    submit(payload) {
      const requestData = {
        ...payload
      };

      this.submitting = true;
      const webhookId = this.$route.params.webhook_id;
      useService.webhookService
        .editWebhook(webhookId, requestData)
        .then(response => {
          this.$router.push({ name: 'web_hook_list' });
          this.showSuccessMessage(`${response.message || this.$t('Edit Webhook Success Message')}`);
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getWebhookDetail(webhookId) {
      this.submitting = true;
      useService.webhookService
        .getWebhook(webhookId)
        .then(response => {
          this.data = {
            ...response.data,
            status: !!response.data.status
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
